import { InternalElement } from "../lib/internal-element.js";
import { css, html } from "lit";
import { customElement } from "lit/decorators.js";
import { unsafeHTML } from "lit/directives/unsafe-html.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
let LegalDisclaimer = class extends InternalElement {
  render() {
    var _a;
    return html`
      <section id="legal-disclaimer">${unsafeHTML(((_a = this.quote) == null ? void 0 : _a.product.legal_disclaimer) || "")}</section>
    `;
  }
};
LegalDisclaimer.styles = css`
    #legal-disclaimer {
      font-size: 0.8em;
      font-family: var(--default-vi-font-family);
    }

    #legal-disclaimer p {
      margin: 0;
    }

    a, a:visited {
      color: var(--default-vi-link-color);
    }

    a:hover {
      text-decoration: none;
    }
  `;
LegalDisclaimer = __decorateClass([
  customElement("legal-disclaimer")
], LegalDisclaimer);
export {
  LegalDisclaimer
};
